import ErrorBoundary from '@/components/ErrorBoundary';
import { BYLINE_TYPE, StandaloneBylineProps } from '@/components/content/Byline';
import { LabradorComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { standaloneComponent } from 'modules/dynamic-components';
import { BylineGroup, BylineGroupProps } from './BylineGroup';

const Byline = standaloneComponent<StandaloneBylineProps>('ContentByline');

export interface StandaloneBylineGroupProps extends StandaloneComponentProps {
  bylines: StandaloneBylineProps[];
  options?: BylineGroupProps & {
    $byline?: StandaloneBylineProps;
  };
}

const priorityMap = {
  [BYLINE_TYPE.AUTHOR]: 1,
  [BYLINE_TYPE.PHOTOGRAPHER]: 2,
  [BYLINE_TYPE.FREE]: 3,
};

const byPriority = (prev: StandaloneBylineProps, cur: StandaloneBylineProps) => {
  const defaultType = BYLINE_TYPE.AUTHOR;
  return priorityMap[prev.type ?? defaultType] - priorityMap[cur.type ?? defaultType];
};

export const StandaloneBylineGroup: StandaloneComponent<StandaloneBylineGroupProps> = ({
  bylines,
  options,
  ...props
}) => {
  const { $byline: bylineCommonProps, ...baseProps } = options || {};

  return (
    <ErrorBoundary>
      <BylineGroup {...baseProps} {...props}>
        {bylines.sort(byPriority).map((byline, index) => (
          <Byline key={index} {...bylineCommonProps} {...byline} />
        ))}
      </BylineGroup>
    </ErrorBoundary>
  );
};

export const standalone = StandaloneBylineGroup;

const LabradorBylineGroup: LabradorComponent = ({ type, data, meta, descendants }) => {
  // TODO: Check descendants for an image. If there is one, use that instead of the default one

  return <StandaloneBylineGroup bylines={data.bylines} options={data.options} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorBylineGroup;
